var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","hover":"","to":'/' + _vm.routeParam,"color":"transparent"}},[_c('v-img',{attrs:{"src":_vm.avi_url,"alt":_vm.name + ' community image',"contain":""}}),_c('v-card-title',{staticClass:"py-1 pl-2 text-subtitle-1 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }